import { transport } from '@opengov/transport';

export const platformApiHost = process.env.PLATFORM_API_HOST || '';

export const platform = transport.url(platformApiHost);

export const getServiceURL = (serviceHost: string) => {
  const hostUrl = serviceHost || platformApiHost;
  return transport.url(hostUrl);
};

export const operate = transport.url(platformApiHost);
